import React from 'react'
import './style.css'
import UserMenu from '../user-menu'
import { Row } from '@mattilsynet/mt-ui'

const TopMenuElements = () => (
  <Row className="TopMenuElements" align="center">
    <UserMenu />
  </Row>
)

export default TopMenuElements
